<div class="spacerWrapper" fxLayout="column">
    <h2 mat-dialog-title class="dialogTitle">{{ title }}</h2>

    <div mat-dialog-content>
        <form [formGroup]="groupEditorForm">
            <div class="inputContainer">
                <label>Name</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="GroupName" />
                    <mat-error *ngIf="groupName.invalid && groupName.touched && groupName.hasError('required')">Missing name.</mat-error>
                    <mat-error *ngIf="groupName.errors?.isNameTaken && groupName.touched">Name has already been taken.</mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div class="spacer" fxFlex></div>

    <div mat-dialog-actions align="end">
        <button mat-raised-button type="submit" color="primary" (click)="onSubmit(groupEditorForm.value)">Save</button>
        <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
    </div>
</div>
